import Orejime from 'orejime';
import Cookies from 'js-cookie';
import {orejime_apps_piano} from "./apps/piano.js";
import {orejime_apps_external_tracker} from "./apps/external-tracker.js";


/**
 * Init orejime configuration.
 */
export function initOrejimeInstance() {

	/**
	 * Init global objects.
	 * @type {{instance: null, isConfirmed: (function(*): boolean)}}
	 */
	window.orejime_instance = {
		/**
		 * Declare orejime main instance. Should be defined after `Orejime.init` call.
		 */
		instance: null,
		isConfirmed: isConfirmed
	}

	// Init the orejime instance.
	window.orejime_instance.instance = Orejime.init(getOrejimeConfig());
}


/**
 * Return the orejime config.
 *
 * @returns {{privacyPolicy: string, translations: {fr: {consentModal: {description: string, title: string}, consentNotice: {learnMore: string, description: string}, decline: string, accept: string}}, lang: string, apps: ({name: string, description: string, title: string, cookies: [string], required: boolean}|{name: string, description: string, callback: function(*, *): (undefined|*), title: string, cookies: string[]})[]}}
 */
function getOrejimeConfig() {
	return {
		privacyPolicy: "protection_donnees_personnelles.html",
		lang: "fr",
		translations: {
			fr: {
				consentModal: {
					title: "Gestion de vos cookies",
					description: "L'Assurance Maladie s'engage, dans le cadre des missions qui lui sont confiées, à assurer la protection, la confidentialité et la sécurité de l'ensemble de vos données personnelles dans le respect de votre vie privée. Lorsque vous naviguez sur notre site, nous pouvons être amenés à déposer différents types de cookies sur votre terminal. Ils ont des finalités différentes décrites ci-dessous. Cette page vous permet de les accepter ou de les refuser de manière globale ou au cas par cas. ",
				},
				consentNotice: {
					learnMore: "Personnaliser",
					description: "Ce site utilise des cookies qui nous permettent de vous proposer une navigation optimale, de mesurer l'audience du site et de nos campagnes de communication, ainsi que de vous proposer des vidéos.",
				},
				accept: "Tout accepter",
				decline: "Tout refuser",
			},
		},
		apps: [
			orejime_apps_external_tracker,
			orejime_apps_piano,
		],
	};
}

/**
 * Check if user confirmed choice.
 *
 * If an appId is given, will check only if appId has been confirmed.
 * If no appId is given, will check if any app has been confirmed.
 *
 * Note that the confirmed status is not the consent status.
 * A confirmed status indicates that the user has explicitly made a choice.
 *
 * @param appId
 * @returns {boolean}
 */
 function isConfirmed(appId) {
	// Check if orejime confirmed cookies has been set.
	if (!appId) {
		return typeof Cookies.get('orejime') !== 'undefined';
	}

	let values = {}
	try {
		values = JSON.parse(Cookies.get('orejime'));
	} catch (e) {
	}

	return typeof values[appId] !== 'undefined';
}
